// Sample daily reports — fully editable. One object per language.
// Rendered by ReportContent; fields are optional and render only when present.

export const REPORTS = {
  en: {
    dir: "ltr",
    greeting: "Good Morning!",
    intro: "Here's your personalized ShubhSamay for today.",
    date: "Tuesday, 21 July 2026",
    labels: {
      outlook: "Today's Overall Outlook",
      dayType: "Today's Day Type",
      summary: "Today's Summary",
      direction: "Today's Direction",
      scores: "Today's Outlook",
      best: "Best Action Window",
      caution: "Use Extra Caution",
      opportunity: "Today's Opportunity",
      focus: "Today's Focus",
      favoured: "Favoured Activities",
      avoid: "Activities to Avoid",
      insight: "Daily Insight",
    },
    overall: {
      badge: "Highly Supportive",
      body: "Today is generally supportive for important decisions, meaningful conversations, and making steady progress. Move forward with confidence, but avoid acting in haste.",
    },
    dayType: { title: "Planning Day" },
    summary:
      "A supportive day for planning, important conversations, and thoughtful decision-making. Prioritize quality over speed, and focus on completing what matters most.",
    direction: {
      title: "Plan Before You Act",
      body: "The best results today are likely to come from thoughtful planning, patience, and disciplined execution rather than quick reactions.",
    },
    scores: [
      { label: "Decision Score", value: "8.4", tag: "Strong" },
      { label: "Energy Score", value: "7.2", tag: "Good" },
      { label: "Money Score", value: "6.8", tag: "Good" },
      { label: "Relationship Score", value: "8.1", tag: "Strong" },
    ],
    best: {
      time: "10:45 AM – 12:30 PM",
      note: "This is the most supportive time today for:",
      items: ["Important meetings", "Key decisions", "Strategic planning", "Starting priority work"],
    },
    caution: {
      time: "3:15 PM – 4:45 PM",
      note: "During this period, try to avoid:",
      items: ["Emotional reactions", "Rushed commitments", "Financial decisions under pressure"],
    },
    opportunity:
      "A meaningful conversation today may open the door to a valuable opportunity in the coming weeks. Stay open to new discussions, strengthen relationships, and follow up where it matters.",
    focus:
      "Consistency will create better results than speed today. Complete your most important tasks before taking on new opportunities.",
    favoured: ["Strategic Planning", "Networking", "Learning", "Client Follow-ups"],
    avoid: ["Impulsive Spending", "Unnecessary Arguments", "Last-minute Commitments"],
    insight:
      "The right timing often creates better outcomes than simply putting in more effort. Take thoughtful action, stay patient, and trust the process you've planned.",
    outro: "Your next personalized report will arrive tomorrow morning at 7:00 AM.",
    closing: "Have a productive day.",
  },

  hi: {
    dir: "ltr",
    greeting: "सुप्रभात!",
    intro: "यह रहा आज का आपका व्यक्तिगत ShubhSamay।",
    date: "मंगलवार, 21 जुलाई 2026",
    labels: {
      outlook: "आज का दिन आपके लिए कैसा है",
      dayType: "आज का दिन",
      summary: "एक नज़र में आज",
      direction: "आज का फोकस",
      scores: "आज का माहौल",
      best: "आज का सबसे सही समय",
      caution: "इस समय थोड़ा संभलकर रहें",
      opportunity: "आज का अवसर",
      focus: "आज का फोकस",
      favoured: "आज इन कामों पर ध्यान दें",
      avoid: "आज इन कामों से बचें",
      insight: "आज की सलाह",
    },
    overall: {
      badge: "काफी अनुकूल",
      body: "आज का दिन आपके लिए काफी अनुकूल है। महत्वपूर्ण निर्णय लेने, नई योजना बनाने, ज़रूरी बातचीत करने और अपने काम को आगे बढ़ाने के लिए आज का माहौल सहयोगी है। आत्मविश्वास रखें, लेकिन जल्दबाज़ी से बचें।",
    },
    dayType: {
      title: "सोच-समझकर आगे बढ़ने का दिन",
      body: "आज सफलता तेज़ी से नहीं, बल्कि सही योजना, धैर्य और समझदारी से लिए गए निर्णयों से मिलने की संभावना अधिक है।",
    },
    summary:
      "आज का दिन योजना बनाने, महत्वपूर्ण बातचीत करने और ज़रूरी काम पूरे करने के लिए अच्छा है। जल्दबाज़ी के बजाय सोच-समझकर लिया गया हर निर्णय आपको बेहतर परिणाम दे सकता है।",
    direction: {
      title: "पहले सोचें, फिर आगे बढ़ें",
      body: "आज किसी भी महत्वपूर्ण काम की शुरुआत पूरी तैयारी और स्पष्ट योजना के साथ करें।",
    },
    scores: [
      { label: "निर्णय क्षमता", value: "8.4", tag: "मजबूत" },
      { label: "ऊर्जा स्तर", value: "7.2", tag: "अच्छा" },
      { label: "आर्थिक माहौल", value: "6.8", tag: "अनुकूल" },
      { label: "रिश्ते एवं संवाद", value: "8.1", tag: "मजबूत" },
    ],
    best: {
      time: "10:45 AM – 12:30 PM",
      note: "यह समय सबसे उपयुक्त रहेगा:",
      items: ["महत्वपूर्ण मीटिंग", "बड़े निर्णय", "नई योजना बनाना", "प्राथमिक कार्य शुरू करना"],
    },
    caution: {
      time: "3:15 PM – 4:45 PM",
      note: "यदि संभव हो तो इस समय:",
      items: ["भावनाओं में आकर प्रतिक्रिया देने से बचें", "जल्दबाज़ी में कोई वादा न करें", "दबाव में आर्थिक निर्णय न लें"],
    },
    opportunity:
      "आज किसी महत्वपूर्ण व्यक्ति से हुई बातचीत भविष्य में आपके लिए एक अच्छा अवसर बना सकती है। नई मुलाकातों को महत्व दें और ज़रूरत पड़ने पर आगे भी संपर्क बनाए रखें।",
    focus:
      "आज गति से अधिक निरंतरता आपको बेहतर परिणाम देगी। पहले अपने सबसे महत्वपूर्ण काम पूरे करें, फिर नए अवसरों की ओर बढ़ें।",
    favoured: ["रणनीतिक योजना", "नए लोगों से जुड़ना", "नई चीज़ें सीखना", "लंबित कार्य पूरे करना"],
    avoid: ["बिना सोचे खर्च करना", "अनावश्यक बहस", "आख़िरी समय पर निर्णय लेना"],
    insight:
      "आज अधिक मेहनत करने से ज़्यादा ज़रूरी है सही समय पर सही निर्णय लेना। धैर्य रखें, स्पष्ट सोच के साथ आगे बढ़ें, और अपने महत्वपूर्ण कार्यों को प्राथमिकता दें।",
    outro: "आपकी अगली व्यक्तिगत रिपोर्ट कल सुबह 7:00 बजे प्राप्त होगी।",
    closing: "आपका दिन सफल और शुभ रहे।",
  },

  hinglish: {
    dir: "ltr",
    greeting: "Good Morning!",
    intro: "Yeh raha aaj ka aapka personalized ShubhSamay.",
    date: "Tuesday, 21 July 2026",
    labels: {
      outlook: "Aaj Ka Din Kaisa Hai",
      dayType: "Aaj Ka Din",
      summary: "Ek Nazar Mein Aaj",
      direction: "Aaj Ka Focus",
      scores: "Aaj Ka Outlook",
      best: "Best Action Window",
      caution: "Is Time Thoda Dhyan Rakhein",
      opportunity: "Aaj Ka Opportunity",
      focus: "Aaj Ka Focus",
      favoured: "Aaj In Kaamon Par Focus Karein",
      avoid: "Aaj In Cheezon Se Bachein",
      insight: "Aaj Ki Insight",
    },
    overall: {
      badge: "Kaafi Supportive",
      body: "Aaj ka din kaafi supportive lag raha hai. Important decisions, planning, meaningful conversations aur steady progress ke liye aaj ka environment favourable hai. Confidence ke saath aage badhein, lekin jaldbazi se bachein.",
    },
    dayType: {
      title: "Soch Samajhkar Aage Badhne Ka Din",
      body: "Aaj best results tab milenge jab aap planning, patience aur disciplined execution par focus karenge. Har decision lene se pehle ek baar zaroor sochiye.",
    },
    summary:
      "Aaj ka din planning, important discussions aur priority work complete karne ke liye accha hai. Quality ko speed se zyada importance dein.",
    scores: [
      { label: "Decision Score", value: "8.4", tag: "Strong" },
      { label: "Energy Score", value: "7.2", tag: "Good" },
      { label: "Money Score", value: "6.8", tag: "Good" },
      { label: "Relationship Score", value: "8.1", tag: "Strong" },
    ],
    best: {
      time: "10:45 AM – 12:30 PM",
      note: "Is time par focus karein:",
      items: ["Important Meetings", "Key Decisions", "Strategic Planning", "Priority Work Start Karna"],
    },
    caution: {
      time: "3:15 PM – 4:45 PM",
      note: "Agar possible ho, toh is duration mein:",
      items: ["Emotional reactions se bachein", "Jaldi commitments na karein", "Pressure mein financial decisions avoid karein"],
    },
    opportunity:
      "Aaj kisi meaningful conversation se future mein ek valuable opportunity mil sakti hai. Naye logon se connect karein, aur zaroori follow-up karna na bhoolein.",
    favoured: ["Strategic Planning", "Networking", "Learning", "Client Follow-ups"],
    avoid: ["Impulsive Spending", "Unnecessary Arguments", "Last-minute Commitments"],
    insight:
      "Aaj zyada kaam karna zaroori nahi hai. Sahi time par sahi decision lena aur priority work par focus karna aapko better results de sakta hai.",
    outro: "Kal subah 7:00 baje aapka agla personalized ShubhSamay WhatsApp par mil jayega.",
    closing: "Have a great day!",
  },
};
